import React, { useState } from 'react';
import PathIcon from '../../../assets/icon-path.svg?react';
import HourglassIcon from '../../../assets/icon-hourglass.svg?react';
import CloseIcon from '../../../assets/icon-close.svg?react';
import { Button } from 'react-bootstrap';
import DeleteModal from '@/components/content/DeleteModal';

interface FileUploadBadgeProps {
  uploadedFileTitle: string;
  knowledgeFileId?: string;
  fileStatus?: boolean;
  showRemoveButton?: boolean;
  onRemove?: (title: string) => void;
}

const FileUploadBadge: React.FC<FileUploadBadgeProps> = ({
  uploadedFileTitle,
  fileStatus,
  knowledgeFileId,
  showRemoveButton = true,
  onRemove,
}) => {
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const handleFileRemove = () => {
    if (knowledgeFileId) {
      setShowDeletePopup(true);
    } else {
      onRemove?.(uploadedFileTitle);
    }
  };

  return (
    <div className="uploaded-file-container" data-testid="uploaded-file-container">
      <div className="uploaded-file-preview">
        <div data-testid="sync-file-icon">
          <PathIcon />
        </div>
        <div className="file-info">
          <div className="file-info-text">
            <p title={uploadedFileTitle} data-testid="sync-file-title">
              {uploadedFileTitle}
            </p>
          </div>
          <div className="uploadedfile-icon-container">
            {fileStatus ? (
              <HourglassIcon data-testid="sync-hourglass-icon" />
            ) : (
              showRemoveButton && (
                <Button
                  variant="link"
                  className="remove-file-btn"
                  onClick={handleFileRemove}
                  aria-label="Remove file"
                >
                  <CloseIcon className="closeIcon" data-testid="sync-close-button" />
                </Button>
              )
            )}
            {showDeletePopup && onRemove && knowledgeFileId && (
              <DeleteModal
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                deleteSourceById={(id?: string) => {
                  if (id) onRemove(id);
                }}
                documentId={knowledgeFileId}
                deleteIconVisible={true}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploadBadge;
